import Vue from "vue";
import VueRouter from "vue-router";
// import local from "../utils/local";
// import { login } from "../api/index";

Vue.use(VueRouter);
import Home from "../pages/Home.vue";
import Profile from "../pages/Profile.vue";
import Solution from "../pages/Solution.vue";
import Cases from "../pages/Cases.vue";
import Experience from "../pages/Experience.vue";
import Aboutus from "../pages/Aboutus.vue";
import Honor from "../pages/Honor.vue";
import Core from "../pages/Core.vue";
import Recruitment from "../pages/Aboutus/Recruitment.vue";
// import  ReDetail from "../pages/ReDetail.vue"
import Detail from "../pages/Detail.vue";
import Contactus from "../pages/Aboutus/Contactus.vue";
import Business from "../pages/Business.vue";
import Test from "../pages/Test.vue";

const routes = [{ //首页
        path: "/test",
        name: "test",
        component: Test,
    },
    { //首页
        path: "/",
        name: "home",
        component: Home,
    },
    { //公司简介
        path: "/profile",
        name: "profile",
        component: Profile,
    },
    { //主营业务
        path: "/business",
        name: "business",
        component: Business,
    },
    { //解决方案
        path: "/solution",
        name: "solution",
        component: Solution,
    },
    { //项目案例
        path: "/cases",
        name: "cases",
        component: Cases,
    },
    { //功能体验
        path: "/experience",
        name: "experience",
        component: Experience,
    },
    // 新闻动态
    {
        path: "/news",
        name: "news",
        component: () =>
            import ("@/pages/News/News")
    },
    // 动态详情
    {
        path: "/newsdetail",
        name: "newsdetail",
        component: () =>
            import ("@/pages/News/NewsDetail")
    },
    // 详情页
    {
        path: "/detail/:name/:id",
        name: "detail",
        component: Detail
    },
    { //关于我们
        path: "/aboutus",
        name: "aboutus",
        component: Aboutus,
    },
    { //表彰荣誉
        path: "/honor",
        name: "honor",
        component: Honor,
    },
    { //关于我们-核心技术
        path: "/core",
        name: "core",
        component: Core,
    },
    { //加入我们-人才招聘
        path: "/recruitment",
        name: "recruitment",
        component: Recruitment,
    },
    // { //加入我们-详情
    //   path: "/ReDetail/:id",
    //   name: "reDetail",
    //   component:ReDetail,
    // }, 
    { //关于我们-联系我们
        path: "/contactus",
        name: "contactus",
        component: Contactus,
    }

]

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// const router = new VueRouter({
//     mode: "hash",
//     base: process.env.BASE_URL,
//     routes,
// });

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

// 匿名访问不需要登录
router.beforeEach((to, from, next) => {
    // console.log("beforeEach", window.location.pathname)
    if (to.query.anonymous === undefined && window.location.pathname != "/") {
        // 强制匿名
        let str = to.fullPath.indexOf("?") > -1 ? '&anonymous' : "?anonymous";
        next(to.fullPath + str);
    } else {
        // 匿名访问
        next();
    }

    //   // next();
    //   // 登录方式
    //   //   let isLogin = local.getCookie("x-token") || "";
    //   //   if (isLogin) {
    //   //     next();
    //   //   } else {
    //   //     let data = { "credential": "xadmin", "password": "o2" };
    //   //     login(data).then((res) => {
    //   //       if (res.type == "success") {
    //   //         let token = res.data.token;
    //   //         if (token) {
    //   //           local.setCookie("x-token", res.data.token, 30);
    //   //           next();
    //   //         } else {
    //   //           console.log("匿名登录，token为空");
    //   //         }
    //   //       }
    //   //     }).catch((err) => {
    //   //       console.log("发生了错误：" + err)
    //   //     })
    //   //   }
});

export default router;